import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=b9c2c330&"
import script from "./EditRole.vue?vue&type=script&lang=js&"
export * from "./EditRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports